import { z } from "zod";
import { ProductItemSchema } from "@/schemas/product/product-item";

export const AccountLicenseItemSchema = z.object({
  Assignments: z.array(z.string().uuid()),
  AvailableCount: z.number().optional(),
  Product: ProductItemSchema,
  TotalCount: z.number(),
});

export type AccountLicenseItemType = z.infer<typeof AccountLicenseItemSchema>;
